import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TopBlockCommands from '../CommandsContainer/TopBlock';

type TopBlockProps = {
    reloadList: () => void;
    permissionCreate: boolean;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate(`/commands/product_completion_sheets/new`);
    };

    return (
        <TopBlockCommands
            actions={[
                {
                    onClick: props.reloadList,
                    icon: <ReloadIcon />,
                    tooltip: translate('productCompletionSheets.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('productCompletionSheets.action.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
